import { InputGroup, InputLeftAddon, Select } from "@chakra-ui/react";
import { t } from "i18next";
import { QUARTERS } from "../../utils";

function QuarterSelector({ selectedQuarter, handleQuarterSelection, groupStyles = {} }) {
  return (
    <InputGroup display="flex" alignItems="center" width="200px" marginBlock={4} {...groupStyles}>
      <InputLeftAddon children={t("quarter")} fontWeight="semibold" />
      <Select
        backgroundColor="white"
        borderRadius="none"
        value={selectedQuarter}
        onChange={(e) => handleQuarterSelection(e.target.value)}
      >
        <option value={QUARTERS.ALL}>{t("quarterAll")}</option>
        <option value={QUARTERS.Q1}>{`${t("quarterLetter")}1`}</option>
        <option value={QUARTERS.Q2}>{`${t("quarterLetter")}2`}</option>
        <option value={QUARTERS.Q3}>{`${t("quarterLetter")}3`}</option>
        <option value={QUARTERS.Q4}>{`${t("quarterLetter")}4`}</option>
      </Select>
    </InputGroup>
  )
}

export default QuarterSelector;